import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Container, Eyebrow, Btn } from './landing/primitives';
import ChatMockup from './landing/ChatMockup';

const EASE = [0.16, 1, 0.3, 1];
const fade = (delay) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay, ease: EASE },
});

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="relative pt-36 sm:pt-44 lg:pt-52 pb-16 lg:pb-24 overflow-hidden" data-testid="hero-section">
      <div
        className="absolute inset-x-0 top-0 h-[70vh] pointer-events-none"
        style={{ background: 'radial-gradient(ellipse 60% 50% at 20% 0%, var(--c-overlay-strong), transparent 70%)' }}
      />

      <Container className="relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-end">
          <div className="lg:col-span-8">
            <motion.div {...fade(0)}>
              <Eyebrow>Sovereign intelligence platform</Eyebrow>
            </motion.div>
            <motion.h1
              {...fade(0.1)}
              className="mt-7 text-5xl sm:text-6xl lg:text-7xl xl:text-[5.75rem] font-heading font-medium tracking-tight leading-[0.98] text-content"
              data-testid="hero-headline"
            >
              Intelligence for<br />the next era.
            </motion.h1>
          </div>

          <motion.div {...fade(0.25)} className="lg:col-span-4 lg:pb-2">
            <p className="text-content text-lg font-medium tracking-tight">Sovereign intelligence. Built to last.</p>
            <p className="mt-3 text-content-2 text-base leading-relaxed" data-testid="hero-subheadline">
              OpenSov AI builds AI products and infrastructure you control — from advanced assistants to enterprise-grade APIs that scale.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Btn onClick={() => navigate('/chat')} data-testid="hero-get-started-btn">
                Get Started
                <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
              </Btn>
              <Btn variant="secondary" onClick={() => navigate('/docs')} data-testid="hero-demo-btn">
                Explore the API
              </Btn>
            </div>
          </motion.div>
        </div>

        <ChatMockup />
      </Container>
    </section>
  );
};

export default Hero;
